import { Component } from '@angular/core';
import { FilterService } from 'primeng/api';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(private filterService: FilterService,private authService: AuthService) {

    //REGISTER THE CUSTOM FILTERS For the app

     //Register a custom filter that will return if the array contains any values in the filter array
     this.filterService.register('includesAny', (value, filter): boolean => {
      if(!filter || filter.length == 0) return true;
      if(!value) return false;
      //Loop through the array and see if the filter contains the GUID
      let has_guid = false;
      value.forEach(item => {
        if(filter.includes(item.guid)) has_guid = true; 
      });
      return has_guid;
    });

    this.filterService.register('includesAll', (value, filter): boolean => {
      if(!filter || filter.length == 0) return true;
      if(!value) return false;
      let hasAll = true;
      //Loop through the array and check if the filter has all the required fields
      filter.forEach(item => {
        var index = value.findIndex(obj => obj.guid==item);
        if(index == -1) hasAll = false;
      })
      return hasAll;
    });
  }
  ngOnInit() {
    this.authService.checkSession().subscribe();
  }
  
}
